import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowDown, faPrint } from '@fortawesome/free-solid-svg-icons';
import { ReportIncomeService } from '../../../services/usuario/report-income.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-informe-rendimentos',
  templateUrl: './informe-rendimentos.component.html',
  styleUrls: ['./informe-rendimentos.component.css']
})
export class InformeRendimentosComponent {
  //ICONES
  faArrowDown = faArrowDown;
  faPrint = faPrint;
  //VARIÁVEIS
  loading: boolean = true;
  incomes: Array<any> = [];
  element!: HTMLElement;
  date = new Date().getFullYear();
  //VARIÁVEIS PAGINAÇÃO
  tamanhoLista: number = 0;
  itensPorPagina: any = 5;
  paginaAtual: any = 1;
  constructor(private router: Router, private reportIncomeService: ReportIncomeService, private toast: ToastrService) {
    this.reportIncomeService.getReportIncome().subscribe((res: any) => {
      this.incomes = res;
      this.tamanhoLista = res.length;
      this.loading = false;
    });
  }
  getItensDaPagina(): any[] {
    const startIndex = (this.paginaAtual - 1) * this.itensPorPagina;
    const endIndex = startIndex + this.itensPorPagina;
    return this.incomes.slice(startIndex, endIndex);
  }
  download(item: any) {
    this.reportIncomeService.getReportIncomeById(item.id).subscribe((data) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
  
        // Se estiver rodando no WebView Android, chama a interface nativa
        if ((window as any).AndroidDownload) {
          (window as any).AndroidDownload.downloadBase64File(base64data, "Informe de Rendimentos - " + item.fileName);
          this.toast.success('Informe de Rendimentos baixado com sucesso!', 'Sucesso');
        } else {
          // Fallback para navegador normal
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "Informe de Rendimentos - " + item.fileName;
          a.href = URL.createObjectURL(data);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
  
          // Exibe o feedback de sucesso após o download
          this.toast.success('Informe de Rendimentos baixado com sucesso!', 'Sucesso');
        }
      };
      reader.readAsDataURL(data); // Converte para Base64
    });
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.itensPorPagina = quantidade;
    this.getItensDaPagina();
  }
  disableDownloadButton(id: any) {
    this.element = document.getElementById(id) as HTMLElement;
    this.element.setAttribute('disabled', 'true');
  }
  enableDownloadButton(id: any) {
    this.element = document.getElementById(id) as HTMLElement;
    this.element.removeAttribute('disabled');
  }
}
